module.exports = __webpack_public_path__ + "img/gc_country_flag_ph.4ed12ab2.svg";